import { getPps } from 'ACTIONS/categories/getPps';
import { API_URLS } from 'CONFIG/API_URLS';
import { PP_TYPE } from 'MODULES/PP_TYPE';

export const getUserLots = (flush = false, activePage, activePath) => dispatch => (
    dispatch(getPps(decodeURIComponent(window.location.pathname), API_URLS.LOTS, PP_TYPE.my, flush, null, activePage, undefined, undefined, undefined, undefined, undefined, true, activePath))
);
